import * as React from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

// Muestra el prefijo fijo +52 (México), permite exactamente 10 dígitos y
// devuelve el string formateado "+52XXXXXXXXXX" (o "" si vacío) al onChange.
export const PhoneField = React.forwardRef(
  ({ value, onChange, className, ...props }, ref) => {
    const digits = (value || "")
      .replace(/\D/g, "")
      .replace(/^52/, "")
      .slice(0, 10);
    const handle = (e) => {
      const d = e.target.value.replace(/\D/g, "").slice(0, 10);
      onChange?.(d ? `+52${d}` : "");
    };
    return (
      <div className="flex items-stretch">
        <span className="inline-flex items-center px-3 border border-r-0 border-input bg-muted text-sm font-mono select-none shrink-0">
          +52
        </span>
        <Input
          ref={ref}
          value={digits}
          onChange={handle}
          inputMode="numeric"
          maxLength={10}
          placeholder="10 dígitos"
          className={cn("rounded-l-none", className)}
          {...props}
        />
      </div>
    );
  }
);
PhoneField.displayName = "PhoneField";
